module.exports = __webpack_public_path__ + "img/2018山东会.0e4b6865.jpg";